<template>
  <div class="auth-container">
    <div class="card card-container">
      <h1>Registracija</h1>
      <Form @submit="handleRegister" :validation-schema="schema">
        <div v-if="!successful">
          <div class="form-group">
            <label for="username">Uporabniško ime</label>
            <Field name="username" type="text" class="form-control" />
            <ErrorMessage name="username" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="email">E-pošta</label>
            <Field name="email" type="email" class="form-control" />
            <ErrorMessage name="email" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="companyName">Naziv podjetja</label>
            <Field name="companyName" type="text" class="form-control" />
            <ErrorMessage name="companyName" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="contactPhone">Kontaktna številka</label>
            <Field name="contactPhone" type="text" class="form-control" />
            <ErrorMessage name="contactPhone" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="idTrgovca">ID Trgovca</label>
            <Field name="idTrgovca" type="text" class="form-control" />
            <ErrorMessage name="idTrgovca" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="password">Geslo</label>
            <Field name="password" type="password" class="form-control" />
            <ErrorMessage name="password" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="passwordConfirm">Potrditev gesla</label>
            <Field name="passwordConfirm" type="password" class="form-control" />
            <ErrorMessage name="passwordConfirm" class="error-feedback" />
          </div>

          <div class="form-group">
            <button class="btn btn-primary btn-block" :disabled="loading">
              <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
              ></span>
              Registracija
            </button>
          </div>
        </div>
      </Form>

      <div
          v-if="message"
          class="alert"
          :class="successful ? 'alert-success' : 'alert-danger'"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Register",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      username: yup
          .string()
          .required("Uporabniško ime je obvezno!")
          .min(3, "Vsebovati mora vsaj 3 znake!")
          .max(20, "Vsebuje lahko največ 20 znakov!"),
      email: yup
          .string()
          .required("E-pošta je obvezna!")
          .email("E-pošta ni veljavna!")
          .max(50, "Vsebuje lahko največ 50 znakov!"),
      companyName: yup
          .string()
          .required("Naziv podjetja je obvezen!")
          .max(120, "Vsebuje lahko največ 120 znakov!"),
      contactPhone: yup
          .string()
          .required("Kontaktna številka je obvezna!")
          .max(50, "Vsebuje lahko največ 50 znakov!"),
      idTrgovca: yup
          .string()
          .required("ID Trgovca je obvezen!"),
      password: yup
          .string()
          .required("Geslo je obvezno!")
          .min(6, "Vsebovati mora vsaj 6 znakov!")
          .max(40, "Vsebuje lahko največ 40 znakov!"),
      passwordConfirm: yup
          .string()
          .oneOf([yup.ref('password'), null], 'Gesli se morata ujemati!')
          .required('Potrditev gesla je obvezna!'),
    });

    return {
      successful: false,
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    handleRegister(user) {
      this.message = "";
      this.successful = false;
      this.loading = true;

      this.$store.dispatch("auth/register", user).then(
          (data) => {
            this.message = data.message;
            this.successful = true;
            this.loading = false;
          },
          (error) => {
            this.message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            this.successful = false;
            this.loading = false;
          }
      );
    },
  },
};
</script>
